import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../MenuButton.jsx'
import useMenuItemAiGenerateAam from '../menuButtons/useMenuItemAiGenerateAam.jsx'
import useMenuItemAiGenerateFam from '../menuButtons/useMenuItemAiGenerateFam.jsx'
import useMenuItemAiGenerateFamdt from '../menuButtons/useMenuItemAiGenerateFamdt.jsx'
import useMenuItemAiGenerateFamra from '../menuButtons/useMenuItemAiGenerateFamra.jsx'
import useMenuItemAiGenerateReq from '../menuButtons/useMenuItemAiGenerateReq.jsx'
import useMenuItemAiGenerateSrfFast from '../menuButtons/useMenuItemAiGenerateSrfFast.jsx'
import useMenuItemAiGenerateSrf from '../menuButtons/useMenuItemAiGenerateSrf.jsx'
import useMenuItemAiGenerateUptIter from '../menuButtons/useMenuItemAiGenerateUptIter.jsx'
import useMenuItemAiGenerateWf from '../menuButtons/useMenuItemAiGenerateWf.jsx'
import useMenuItemAiGenerateWs from '../menuButtons/useMenuItemAiGenerateWs.jsx'
import useMenuItemAiGenerateAis from './useMenuItemAiGenerateAis.jsx'
import useMenuItemAiGenerateAsd from './useMenuItemAiGenerateAsd.jsx'
import useMenuItemAiGenerateFa from './useMenuItemAiGenerateFa.jsx'
import useMenuItemAiGenerateLsm from './useMenuItemAiGenerateLsm.jsx'
import useMenuItemAiGenerateNdt from './useMenuItemAiGenerateNdt.jsx'
import useMenuItemAiGenerateNspec from './useMenuItemAiGenerateNspec.jsx'
import useMenuItemAiGenerateSpec from './useMenuItemAiGenerateSpec.jsx'
import useMenuItemAiGenerateUdt from './useMenuItemAiGenerateUdt.jsx'
import useMenuItemAiGenerateUfmd from './useMenuItemAiGenerateUfmd.jsx'
import useMenuItemAiGenerateUptFa from './useMenuItemAiGenerateUptFa.jsx'
import useMenuItemAiGenerateUspec from './useMenuItemAiGenerateUspec.jsx'

export default function MenuButtonAi(props) {
    const map = useMapContext()
    const {mapTypeCode} = map.data

    const items = [
        {
            label: '新建',

            children: [
                useMenuItemAiGenerateAam(),
                useMenuItemAiGenerateAsd(),
                useMenuItemAiGenerateFa(),
                useMenuItemAiGenerateFam(),
                useMenuItemAiGenerateFamra(),
                useMenuItemAiGenerateFamdt(),
                useMenuItemAiGenerateNdt(),
                useMenuItemAiGenerateWs({label: '新建知识结构'}),
                useMenuItemAiGenerateWf({label: '新建业务流程'}),
                useMenuItemAiGenerateLsm(),
            ],
        },

        {
            label: '迭代',

            children: [
                useMenuItemAiGenerateUptFa(),
                //useMenuItemAiGenerateUfmd(),
                useMenuItemAiGenerateAis(),
                //useMenuItemAiGenerateUptIter(),
                useMenuItemAiGenerateSrfFast(),
                useMenuItemAiGenerateSrf(),
                useMenuItemAiGenerateUdt(),
            ],
        },

        {
            label: '其他',

            children: [
                useMenuItemAiGenerateReq(),
                useMenuItemAiGenerateSpec(),
                useMenuItemAiGenerateNspec(),
                useMenuItemAiGenerateUspec(),
            ],
        },
    ]

    if ('SA_MAP' !== mapTypeCode) {
        return null
    }

    return (
        <MenuButton
            items={items}
            {...props}
        >
            AI助手
        </MenuButton>
    )
}
